import { type NeveredIngredientProduct } from '@hungryroot/rest';

/** product id → unique nevered-ingredient display names on that product */
export type NeveredIngredientProductLookup = Map<number, string[]>;

export function buildNeveredIngredientProductLookup(
  results: NeveredIngredientProduct[] | undefined
): NeveredIngredientProductLookup {
  const lookup: NeveredIngredientProductLookup = new Map();
  if (!results?.length) return lookup;

  for (const product of results) {
    if (!product?.id || !product.nevered_ingredients?.length) continue;

    const names: string[] = [];
    for (const ingredient of product.nevered_ingredients) {
      if (ingredient?.name && !names.includes(ingredient.name))
        names.push(ingredient.name);
    }
    if (names.length > 0) lookup.set(product.id, names);
  }

  return lookup;
}

export function productHasNeveredIngredient(
  productId: number,
  lookup: NeveredIngredientProductLookup
): boolean {
  return (lookup.get(productId)?.length ?? 0) > 0;
}

export function getNeveredIngredientNamesForProducts(
  productIds: number[],
  lookup: NeveredIngredientProductLookup
): string[] {
  if (!productIds.length || lookup.size === 0) return [];

  const names: string[] = [];
  for (const productId of productIds) {
    const productNames = lookup.get(productId);
    if (!productNames) continue;
    for (const name of productNames) {
      if (!names.includes(name)) names.push(name);
    }
  }
  return names;
}
